import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  VStack,
  HStack,
  Text,
  Link,
  Icon,
  Divider,
  Button,
  Image
} from '@chakra-ui/react';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaPhone,
  FaEnvelope
} from 'react-icons/fa';


const Footer = () => {
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';

  const socialLinks = [
    { icon: FaFacebook, url: '#', color: '#1877F2' },
    { icon: FaInstagram, url: '#', color: '#E4405F' },
    { icon: FaYoutube, url: '#', color: '#FF0000' }
  ];

  return (
    <Box 
      bg={secondaryColor} 
      color="white" 
      py={8} 
      dir="rtl"
      fontFamily="Tajawal, sans-serif" // Changed font to Tajawal
    >
      <Container maxW="8xl">
        <VStack spacing={8} align="stretch">
          {/* Main Content */}
          <HStack 
            spacing={8} 
            justify="space-between"
            flexWrap="wrap"
            align="flex-start"
          >
            {/* Logo and Description */}
            <VStack align="flex-start" spacing={4} maxW="300px">
              <Image 
               src="https://i.imgur.com/EFLnpkN.png"
                alt="منصة كوبرا التعليمية" 
                h="50px" // Adjust height as needed
                objectFit="contain"
              />
              <Text fontSize="sm" lineHeight="1.6">
                الرائدة في التعليم الإلكتروني في تونس
              </Text>
              <HStack spacing={3}>
     
              </HStack>
            </VStack>

            {/* Contact Info */}
            <VStack align="flex-start" spacing={3}>
              <Text fontWeight="bold" color={primaryColor}>تواصل معنا</Text>
              <HStack spacing={3}>
                <Icon as={FaPhone} w={4} h={4} />
                <Text fontSize="sm">22779137</Text>
              </HStack>
              <HStack spacing={3}>
                <Icon as={FaWhatsapp} w={4} h={4} />
                <Text fontSize="sm">22779137</Text>
              </HStack>
              <HStack spacing={3}>
                <Icon as={FaEnvelope} w={4} h={4} />
                <Text fontSize="sm">loussifiacademy@gmail.com</Text>
              </HStack>
            </VStack>

            {/* Quick Links */}
            <VStack align="flex-start" spacing={3}>
              <Text fontWeight="bold" color={primaryColor}>روابط سريعة</Text>
              <Link as={RouterLink} to="/" fontSize="sm" _hover={{ color: primaryColor }}>الرئيسية</Link>
              <Link as={RouterLink} to="/packs" fontSize="sm" _hover={{ color: primaryColor }}>الباقات</Link>
              <Link as={RouterLink} to="/about" fontSize="sm" _hover={{ color: primaryColor }}>حول المنصة</Link>
              <Link as={RouterLink} to="/contact" fontSize="sm" _hover={{ color: primaryColor }}>اتصل بنا</Link>
            </VStack>

            {/* WhatsApp Button */}
            <Button
              as="a"
              href="https://wa.me/21622779137"
              target="_blank"
              bg={primaryColor}
              color={secondaryColor}
              _hover={{ bg: '#d4b016' }}
              rightIcon={<FaWhatsapp />}
              size="sm"
              alignSelf="center"
              fontFamily="Tajawal, sans-serif"
            >
              تواصل عبر واتساب
            </Button>
          </HStack>

          <Divider borderColor="gray.600" />

          {/* Copyright */}
          <HStack justify="space-between" flexWrap="wrap">
            <Text fontSize="sm">
              © 2024 منصة كوبرا التعليمية. جميع الحقوق محفوظة.
            </Text>
            <HStack spacing={4}>
              {/* You can add additional links here if needed */}
            </HStack>
          </HStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;